import React from 'react';

const HelpFooter: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white py-8 mt-16">
      <div className="max-w-5xl mx-auto px-4">
        <div className="mb-6">
          <h2 className="text-xl font-bold mb-4">RepliGo</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-medium mb-2">運営情報</h3>
              <ul className="space-y-1 text-gray-300">
                <li>RepliGo（レプリゴ）</li>
                <li>運営：ForceAI 安田 陸</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-medium mb-2">サポート連絡先</h3>
              <p className="text-gray-300">
                ご不明点・不具合・ご要望は下記までご連絡ください：<br />
                <a 
                  href="mailto:yasuda_riku@forceai.jp" 
                  className="text-blue-300 hover:text-blue-200 underline transition-colors"
                >
                  yasuda_riku@forceai.jp
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-4 text-sm text-gray-400 text-center">
          <p>© 2025 Force AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default HelpFooter;